/* eslint-disable @typescript-eslint/quotes*/
import { Component, OnInit } from '@angular/core';
import { take } from 'rxjs/operators';
import { AuthState } from '@app/auth/auth.state';
import { env } from '@envs/env';
import { OAuthService } from './auth/oauth.service';
import { AppService } from './app.service';
import { HeaderState } from './header/header.state';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
    loggedIn: boolean = false;

    constructor(
        private authState: AuthState,
        private oauthService: OAuthService,
        private appService: AppService,
        private headerState: HeaderState
    ) {
        AppService.self = this.appService;
    }

    ngOnInit() {
        // amplitude script
        const ampl = this.generateAmplitudeScript();
        document.head.appendChild(ampl);

        this.authState
            .emitAuthComplete()
            .pipe(take(1))
            .subscribe(() => {
                // Intercom script
                const el = this.generateIntercomScript();
                document.head.appendChild(el);
                // apply user id to amplitude
                this.initializeAmplitude();
                // logged equals true allows the app page render which enables the location init and triggers the headerState subscription
                this.loggedIn = true;
            });

        // subscribe to location changes and update intercom status
        this.headerState.onChangeLocation().subscribe((loc) => {
            if (loc) {
                // set user and utility on Intercom and set Amplitude user
                this.initializeIntercom(loc);
            }
        });
    }

    initializeAmplitude() {
        this.authState.getUser().subscribe((user) => {
            if (user) {
                (window as any).amplitude.getInstance().setUserId(user.id);
            }
        });
    }

    initializeIntercom(location) {
        this.authState.getUser().subscribe((user) => {
            if (user) {
                const entitlement = user.plan.entitlement.toLowerCase();
                const installationStatus = location.installation.toLowerCase();
                const showIntercom = installationStatus !== 'done' || entitlement !== 'basic';
                if (showIntercom) {
                    (window as any).Intercom('boot', {
                        app_id: env.intercom,
                        user_id: user.id,
                        email: user.email_address,
                    });
                } else {
                    (window as any).Intercom('shutdown');
                }
            }
        });
    }

    generateIntercomScript() {
        const el = document.createElement('script');
        el.type = 'text/javascript';
        el.innerHTML =
            '(function(){var w=window;var ic=w.Intercom;if(typeof ic==="function"){ic(\'reattach_activator\');' +
            "ic('update',w.intercomSettings);}else{var d=document;var i=function(){i.c(arguments);};i.q=[];" +
            "i.c=function(args){i.q.push(args);};w.Intercom=i;var l=function(){var s=d.createElement('script');" +
            `s.type='text/javascript';s.async=true;s.src='https://widget.intercom.io/widget/${env.intercom}';` +
            "var x=d.getElementsByTagName('script')[0];x.parentNode.insertBefore(s, x);};if(document.readyState==='complete')" +
            "{l();}else if(w.attachEvent){w.attachEvent('onload',l);}else{w.addEventListener('load',l,false);}}})();";
        return el;
    }

    generateAmplitudeScript() {
        const ampl = document.createElement('script');
        ampl.type = 'text/javascript';
        ampl.innerHTML = `(function(e,t){var n=e.amplitude||{_q:[],_iq:{}};var r=t.createElement("script")
            ;r.type="text/javascript";r.async=true
            ;r.src="https://cdn.amplitude.com/libs/amplitude-4.5.2-min.gz.js"
            ;r.onload=function(){if(e.amplitude.runQueuedFunctions){
            e.amplitude.runQueuedFunctions()}else{
            console.log("[Amplitude] Error: could not load SDK")}}
            ;var i=t.getElementsByTagName("script")[0];i.parentNode.insertBefore(r,i)
            ;function s(e,t){e.prototype[t]=function(){
            this._q.push([t].concat(Array.prototype.slice.call(arguments,0)));return this}}
            var o=function(){this._q=[];return this}
            ;var a=["add","append","clearAll","prepend","set","setOnce","unset"]
            ;for(var u=0;u<a.length;u++){s(o,a[u])}n.Identify=o;var c=function(){this._q=[]
            ;return this}
            ;var l=["setProductId","setQuantity","setPrice","setRevenueType","setEventProperties"]
            ;for(var p=0;p<l.length;p++){s(c,l[p])}n.Revenue=c
            ;var d=["init","logEvent","logRevenue","setUserId","setUserProperties","setOptOut",
            "setVersionName","setDomain","setDeviceId","setGlobalUserProperties","identify",
            "clearUserProperties","setGroup","logRevenueV2","regenerateDeviceId","logEventWithTimestamp",
            "logEventWithGroups","setSessionId","resetSessionId"]
            ;function v(e){function t(t){e[t]=function(){
            e._q.push([t].concat(Array.prototype.slice.call(arguments,0)))}}
            for(var n=0;n<d.length;n++){t(d[n])}}v(n);n.getInstance=function(e){
            e=(!e||e.length===0?"$default_instance":e).toLowerCase()
            ;if(!n._iq.hasOwnProperty(e)){n._iq[e]={_q:[]};v(n._iq[e])}return n._iq[e]}
            ;e.amplitude=n})(window,document);
            amplitude.getInstance().init("${env.amplitude}")`;
        return ampl;
    }
}
